import {
  AppRouteParams,
  AppRouteQueryParams,
  PathParamDef,
  QueryParamDef,
  RouteDef,
  RouteWithParams,
} from 'common/src/modules/routing/routing.types';
import {RootState} from 'common/src/redux/store';

function defaultRouteFormatter({
  routeDef,
  route,
}: {
  routeDef: RouteDef;
  route: RouteWithParams;
  getState: () => RootState;
}): string {
  const pathResult = _formatPathParams(routeDef.pathParams, route.pathParamValues);
  const queryResult = _formatQueryParams(routeDef.queryParams, route.queryParamValues);

  return [pathResult, queryResult].filter(Boolean).join('\n');
}

function _formatPathParams(pathParamDefs: PathParamDef[], pathParamValues: AppRouteParams): string {
  if (pathParamDefs.length === 0) {
    return '';
  }

  let result = '';

  for (const pathParamDef of pathParamDefs) {
    const value = pathParamValues[pathParamDef.key];

    const valueToDisplay = value ?? pathParamDef.defaultValue;

    if (valueToDisplay) {
      result += `${result ? '\n' : ''}- ${pathParamDef.displayName}: ${valueToDisplay}`;
    }
  }

  return result;
}

function _formatQueryParams(
  queryParamDefs: QueryParamDef[],
  queryParamValues: AppRouteQueryParams,
): string {
  if (queryParamDefs.length === 0) {
    return '';
  }

  let result = '';

  for (const queryParamDef of queryParamDefs) {
    const value = queryParamValues[queryParamDef.key];

    const valueToDisplay = value ?? queryParamDef.defaultValue;

    if (valueToDisplay !== undefined && valueToDisplay !== null) {
      const formattedValue = Array.isArray(valueToDisplay)
        ? valueToDisplay.join(', ')
        : String(valueToDisplay);

      result += `${result ? '\n' : ''}- ${queryParamDef.displayName}: ${formattedValue}`;
    }
  }

  return result;
}

export default defaultRouteFormatter;
